import { FunctionComponent, SVGProps } from 'react'
import { EmailSentSVG, ThumbsUpSVG } from 'assets/icons'

/*
 ** if you didn't set an icon, the default one is '⚠️'
 */
const alertMessages: { [key: string]: AlertMessageType } = {
  invalid_credentials: {
    status: 'error',
    message: 'Incorrect email or password.',
  },
  user_exists: {
    status: 'error',
    message: 'This account already exists.',
  },
  reset_email_sent: {
    status: 'success',
    message: 'We have emailed you a link to reset your password',
    icon: EmailSentSVG,
  },
  email_changed_successfully: {
    status: 'success',
    message:
      'Email changed successfully, We have sent you a link to confirm the change to your inbox',
    icon: EmailSentSVG,
  },
  basic_info_success: {
    status: 'success',
    message: 'Profile updated successfully',
    icon: ThumbsUpSVG,
  },
  password_changed_successfully: {
    status: 'success',
    message: 'Password changed successfully',
    icon: ThumbsUpSVG,
  },
  cannot_reset_password: {
    status: 'error',
    message: 'Reset password failed, please try again',
  },
  candidate_not_found: {
    status: 'error',
    message: 'This email does not exist.',
  },
  greenhouse_error: {
    status: 'error',
    message: 'Something wrong happened, please reach out to us for help',
  },
  no_active_applications: {
    status: 'error',
    message: 'Your application has to be active in order to change your email',
  },
  email_in_use: {
    status: 'error',
    message:
      'Email already in use, if you think this is a mistake, please reach out to us',
  },
  incorrect_password: {
    status: 'error',
    message: 'The old password is incorrect',
  },
  same_as_old_password: {
    status: 'error',
    message: 'New password is same as old password',
  },
  JWT_malformed: {
    status: 'error',
    message: 'Wrong reset password code',
  },
  unknown_error: {
    status: 'error',
    message: 'something wrong happened, please try again',
  },
  profile_basic_success: {
    status: 'success',
    message: 'Profile updated successfully',
    icon: ThumbsUpSVG,
  },
}

export type AlertMessageType = {
  status: 'error' | 'success'
  message: string
  icon?: FunctionComponent<SVGProps<SVGSVGElement>>
}

export default alertMessages
